import * as ActionsTypes from "../../../../common/constants/stateConstants";

export const confirmerPaiementSouscriptionAction = (payload) => {
  return {
    type: ActionsTypes.CONFIRMER_PAIEMENT_SOUSCRIPTION,
    payload,
  };
};

export const confirmerPaiementSouscriptionSuccessAction = (payload) => {
  return {
    type: ActionsTypes.CONFIRMER_PAIEMENT_SOUSCRIPTION_SUCCESS,
    payload,
  };
};

export const confirmerPaiementSouscriptionFailAction = (payload) => {
  return {
    type: ActionsTypes.CONFIRMER_PAIEMENT_SOUSCRIPTION_FAIL,
    payload,
  };
};

export const confirmerPaiementSouscriptionReinitializationAction = (
  payload
) => {
  return {
    type: ActionsTypes.CONFIRMER_PAIEMENT_SOUSCRIPTION_REINITIALIZATION,
    payload,
  };
};
